export default {
      id: "ic_fast_deposit_close-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_fast_deposit_close-usage",
      toString: function () {
        return this.url;
      }
    }